export default __webpack_public_path__ + "static/media/milian.3de063cc.jpg";